import { FontManager } from "@samuelmeuli/font-manager";

export const initGoogleFonts = () => {
    if (window.google && window.google.fonts) {
        return;
    }

    const fontManager = new FontManager("AIzaSyCK-FT-TdFUvWTWBQ_hxsoU_HS6GHeytWg", "Roboto", {
        pickerId: "icastGoogleFontsPicker",
    });
    fontManager.init().then(() => {
        console.log("Google Fonts initialized");
        console.log("Available fonts:", fontManager.getFonts());
    }).catch((error) => {
        console.error("Error initializing Google Fonts:", error);
    });

    window.google = {
        fonts: {
            load: () => {
                console.log('Google Fonts loaded');
            }
        }
    };
}
